<div class="container-fluid parametrizacao-limites">
  <h3>Parametrização de Limites</h3>
  <div
    *ngIf="isLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 170px;">
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
  <mat-card [hidden]="isLoading">
    <table mat-table [dataSource]="listaItems">
      <ng-container matColumnDef="tipoManifesto">
        <th mat-header-cell *matHeaderCellDef> Tipo de Manifesto</th>
        <td mat-cell *matCellDef="let element"> {{ element.descricao }} </td>
      </ng-container>
      <ng-container matColumnDef="valorLimite">
        <th mat-header-cell *matHeaderCellDef> Valor Limite </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" style="max-width: 300px">
            <input 
              matInput
              currencyMask
              [(ngModel)]="element.valorLimite"
              (keyup.enter)="editarParametrizacaoLimiteValor(element, 'valorLimite', $event.target)">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="bloqueiaOperacao">
        <th mat-header-cell *matHeaderCellDef> Bloqueia Operação </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [(ngModel)]="element.bloqueiaOperacao"
            (change)="editarParametrizacaoLimiteValor(element, 'bloqueiaOperacao', $event.checked)">
          </mat-slide-toggle>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>        
  </mat-card>
</div>
